import React from "react";
import CommonModal from "../../../components/CommonModal";
import PreviewDeployedWebsite from "../components/PreviewDeployedWebsite";

const PreviewModal = ({ url, close }) => {
  return (
    <>
      <CommonModal
        title="Preview Website"
        modal={!!url}
        setModal={() => close()}
        modalSize="xl"
      >
        <PreviewDeployedWebsite deployedUrl={url} />
      </CommonModal>
    </>
  );
};

export default PreviewModal;
